export default {
  panel: {
    comprehensiveStats: '综合信息统计',
    jobDataStats: '作业数据统计',
    deviceData: '设备数据',
  },
  projectTab: {
    all: '整体',
    shenzhen: '深圳项目',
    shanghai: '上海项目',
    chengdu: '成都项目',
  },
  table: {
    deviceName: '设备名',
    deviceCount: '设备数量',
    taskCount: '执行任务数',
    alertCount: '告警数',
  },
  deviceNames: {
    uav: '无人机',
    robotDog: '机器狗',
    robot: '机器人',
  },
  deviceStatus: {
    online: '在线',
    offline: '离线',
  },
  mapDeviceOffline: '设备离线，暂不可查看详情',
  // 同点位设备聚合
  cluster: {
    panelTitle: '该点位设备',
    count: '共 {count} 个',
    empty: '暂无设备',
  },
  mapMarkerStyle: {
    label: '地图图标',
    tech: '极简科技',
    business: '扁平商务',
  },
  deviceTotalLabel: {
    airport: '机场',
    chargingPile: '充电桩',
    total: '总数',
  },
  jobDataLabel: {
    totalFlightDuration: '总飞行时长(H)',
    totalRunDuration: '总运行时长(H)',
    totalMileage: '总里程(Km)',
    totalFlightTrips: '总飞行架次',
    totalDispatchCount: '总出动次数',
  },
  loadingTip: '正在努力加载...',

  // 地图中心点搜索
  centerSearch: {
    placeholder: '搜索地点或设备，如：机器狗 / 机场',
    locate: '定位',
    emptyTip: '请输入地点或设备名称 / SN',
    notReady: '地图尚未就绪，请稍后再试',
    noResult: '未找到"{keyword}"相关地点或设备',
    kindPlace: '地点',
    kindDevice: '设备',
    kindDock: '机场',
  },

  // 告警信息面板
  alarmInfo: {
    panel: {
      title: '告警信息',
    },
    deviceTypes: {
      uav: '无人机',
      robotDog: '机器狗',
      robot: '机器人',
    },
    table: {
      alarmType: '告警类型',
      reportTime: '上报时间',
      preview: '预览',
    },
    empty: {
      noData: '暂无数据',
      noAlarmRecords: '当前筛选下没有告警记录',
    },
    loading: '加载中...',
    noMoreData: '没有更多了',
    loadMore: '下拉加载更多',
  },

  // 设备列表页面
  deviceList: {
    refresh: {
      title: '刷新设备列表',
      buttonText: '刷新',
      updatedAt: '更新于',
    },
    stats: {
      totalDevices: '总设备数',
      onlineDevices: '在线设备',
      offlineDevices: '离线设备',
      clickFilterAll: '点击筛选 · 全部设备',
      percentage: '占比',
    },
    device: {
      unnamed: '未命名设备',
      sn: '设备SN',
      type: '设备类型',
      battery: '电量',
      batteryAlarm: '电量低',
      selfCheck: '自检状态',
      selfCheckNormal: '正常',
      selfCheckAbnormal: '异常',
    },
    empty: {
      noData: '暂无设备数据',
      noOnline: '暂无在线设备',
      noOffline: '暂无离线设备',
      retryLater: '请稍后再试',
    },
    category: {
      label: '分类',
      all: '全部',
      piano: '钢琴机器人',
      dance: '跳舞机器人',
      tem: '搬运机器人',
    },
    loading: '加载中...',
  },

  // 任务列表页面
  taskList: {
    viewMode: {
      table: '表格',
      card: '卡片',
    },
    filters: {
      taskNamePlaceholder: '任务名称',
      deviceSNPlaceholder: '设备序列号',
      mapNamePlaceholder: '地图名称',
      query: '查询',
      reset: '重置',
    },
    actions: {
      createTask: '创建任务',
      inspectionReport: '巡检报告',
      mediaRecord: '媒体记录',
      liveExecution: '执行实况',
      repeatExecution: '重复执行',
      delete: '删除',
    },
    table: {
      taskName: '任务名称',
      deviceSN: '设备序列号',
      progress: '执行进度',
      map: '地图',
      status: '状态',
      createTime: '创建时间',
      actions: '操作',
    },
    card: {
      unnamedTask: '未命名任务',
      deviceSN: '设备SN：',
      map: '地图：',
      createTime: '创建时间：',
      progress: '执行进度：',
    },
    status: {
      idle: '待开始',
      running: '进行中',
      paused: '已暂停',
      completed: '已完成',
      failed: '已失败',
      cancelled: '已取消',
      mapSwitching: '地图切换中',
      mapFailed: '地图切换失败',
      pendingRun: '待执行',
      unknown: '未知',
    },
    empty: {
      noData: '暂无任务数据',
    },
    loading: '加载中...',
    messages: {
      missingDeviceSN: '该任务缺少设备序列号，无法打开实况',
      cannotCopy: '无法复制：缺少任务 ID',
      copySuccess: '已复制并创建新任务',
      copyFailed: '复制失败',
      dogOfflineCannotExecute: '机器狗不在线，无法执行任务',
      cannotDelete: '无法删除：缺少任务 ID',
      deleteRestriction: '仅已完成或超过 1 小时仍未结束的任务可删除',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
    },
    deleteConfirm: {
      title: '确认删除任务',
      content: '删除后不可恢复，相关数据将被清除。',
      okText: '确认删除',
      cancelText: '取消',
    },
  },

  // 创建任务模态框
  createTask: {
    modal: {
      title: '创建任务',
      okText: '确认',
      cancelText: '取消',
    },
    steps: {
      selectDevice: '选择机器狗',
      selectMap: '选择地图',
      confirmTask: '确认任务',
      stepTip: '点击步骤条可快速切换',
    },
    device: {
      unnamed: '未命名设备',
      online: '在线',
      offline: '离线',
      empty: '暂无设备',
      noOnlineDevice: '当前没有在线的机器狗',
      deviceOffline: '该设备离线，无法选择',
      cannotExecute: '该机器狗当前无法执行任务',
      selectDeviceFirst: '请先选择机器狗',
    },
    map: {
      noDescription: '暂无描述',
      noMapAvailable: '该机器狗暂无可用地图',
      selectMapFirst: '请先选择地图',
    },
    points: {
      selectPoints: '选择点位',
      selectedCount: '选择点位',
      noPointsAvailable: '该地图暂无可用点位',
      selectAtLeastOne: '请至少选择一个点位',
    },
    form: {
      taskName: '任务名称',
      taskNamePlaceholder: '请输入任务名称',
      taskNameRequired: '请输入任务名称',
      taskNameLength: '任务名称长度为2-50个字符',
    },
    messages: {
      submitInConfirmStep: '请通过步骤条进入"确认任务"后再提交',
      enterConfirmStep: '请通过步骤条进入"确认任务"后再提交',
      taskCreatedSuccess: '任务创建成功',
      taskCreatedFailed: '任务创建失败',
    },
    validation: {
      enterTaskName: '请输入任务名称',
      selectAtLeastOnePoint: '请至少选择一个点位',
    },
  },
}
